import { useEffect, useState } from "react"
import { useGetAllCategoriesQuery } from "services/household/categories"
import { useGetAttributesQuery } from "services/household/attributes"
import { useGetModalitiesQuery } from "services/household/modalities"
import { useGetOrganizationsQuery } from "services/household/organizations"
import { useGetAssessmentStatusesQuery, useGetPhasesQuery } from "services/household/survey"

const useSurveyList = () => {
  const [isAllLoaded, setIsAllLoaded] = useState<boolean>(false)
  const { data: categories, isSuccess: isSuccessCategories } = useGetAllCategoriesQuery()
  const { data: attributes, isSuccess: isSuccessAttributes } = useGetAttributesQuery()
  const { data: modalities, isSuccess: isSuccessModalities } = useGetModalitiesQuery()
  const { data: statuses, isSuccess: isSuccessStatuses } = useGetAssessmentStatusesQuery()
  const { data: phases, isSuccess: isSuccessPhases } = useGetPhasesQuery()
  const { data: organizations, isSuccess: isSuccessOrganizations } = useGetOrganizationsQuery()

  useEffect(() => {
    if (
      isSuccessCategories &&
      isSuccessAttributes &&
      isSuccessModalities &&
      isSuccessStatuses &&
      isSuccessPhases &&
      isSuccessOrganizations
    ) {
      setIsAllLoaded(true)
    }
  }, [
    isSuccessCategories,
    isSuccessAttributes,
    isSuccessModalities,
    isSuccessStatuses,
    isSuccessPhases,
    isSuccessOrganizations,
  ])

  return { categories, attributes, modalities, statuses, phases, organizations, isAllLoaded }
}

export default useSurveyList
